// src/admin/pages/AdminCustomers.js
import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { 
    FaSearch, 
    FaUserSlash, 
    FaUserShield, 
    FaEye,
    FaPlus,
    FaTrash,
    FaInbox
} from "react-icons/fa";
import { FiCalendar } from "react-icons/fi";
import {
  getAdminCustomers,
  toggleAdminCustomerStatus,
} from "../../services/adminCustomers.api";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { getCommunityEmails } from "../../services/adminCommunity.api";
import { FiMail, FiPhone, FiUsers } from "react-icons/fi";
import { deleteAdminCustomer } from "../../services/adminCustomers.api";

function AdminCustomers() {
    const [isOpen, setIsOpen] = useState(false);


    const emailPrintRef = React.useRef();
const phonePrintRef = React.useRef();
const communityPrintRef = React.useRef();

const [sortBy, setSortBy] = useState(null);

    const [customers, setCustomers] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);
    
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");

    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { lang } = useContext(AdminLanguageContext);

    const [whatsappOpen, setWhatsappOpen] = useState(false);
    const [whatsappMessage, setWhatsappMessage] = useState("");

    const [emailOpen, setEmailOpen] = useState(false);
    const [emailMessage, setEmailMessage] = useState("");
    const [emailSubject, setEmailSubject] = useState(""); 

    const [searchOpen, setSearchOpen] = useState(false);

const [sortOpen, setSortOpen] = useState(false);
const [sortField, setSortField] = useState("date");
const [sortDirection, setSortDirection] = useState("asc");

const [dateOverlayOpen, setDateOverlayOpen] = useState(false);

    const [listOpen, setListOpen] = useState(false);
    const [listType, setListType] = useState(null); 

    const [communityOpen, setCommunityOpen] = useState(false);
const [communityEmails, setCommunityEmails] = useState([]);
const [communityPage, setCommunityPage] = useState(1);

const [toast, setToast] = useState(null);

const [rangeStart, setRangeStart] = useState(null);
const [rangeEnd, setRangeEnd] = useState(null);

const PER_PAGE = 10;

const ADMIN_CUSTOMERS_PAGE_KEY = "adminCustomersCurrentPage";

const getValidPage = (value) => {
  const n = Number(value || 1);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 1;
};

const getInitialPage = () => {
  const urlPage = searchParams.get("page");
  const savedPage = sessionStorage.getItem(ADMIN_CUSTOMERS_PAGE_KEY);
  return getValidPage(urlPage || savedPage || 1);
};

const [page, setPage] = useState(getInitialPage);
const perPage = 10;

useEffect(() => {
  const urlPage = searchParams.get("page");
  const savedPage = sessionStorage.getItem(ADMIN_CUSTOMERS_PAGE_KEY);
  const nextPage = getValidPage(urlPage || savedPage || 1);

  if (nextPage !== page) {
    setPage(nextPage);
  }

  if (!urlPage && nextPage > 1) {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("page", String(nextPage));
      return params;
    });
  }
}, [searchParams, page, setSearchParams]);

const goToCustomersPage = (nextPage) => {
  const rawNext = typeof nextPage === "function" ? nextPage(page) : nextPage;
  const safePage = getValidPage(rawNext);

  setPage(safePage);

  if (safePage <= 1) {
    sessionStorage.removeItem(ADMIN_CUSTOMERS_PAGE_KEY);
  } else {
    sessionStorage.setItem(ADMIN_CUSTOMERS_PAGE_KEY, String(safePage));
  }

  setSearchParams((prev) => {
    const params = new URLSearchParams(prev);

    if (safePage <= 1) {
      params.delete("page");
    } else {
      params.set("page", String(safePage));
    }

    return params;
  });
};

const didMountCustomerFiltersRef = useRef(false);

const [selectedCustomers, setSelectedCustomers] = useState([]);
const [deleteId, setDeleteId] = useState(null);

const [statusFilter, setStatusFilter] = useState("all");

const [communityEmailOpen, setCommunityEmailOpen] = useState(false);
const [communityEmailSubject, setCommunityEmailSubject] = useState("");
const [communityEmailMessage, setCommunityEmailMessage] = useState("");


const exportCSV = (data) => {
  const headers = ["Name", "Email", "Phone", "Orders", "Spent"];

  const rows = data.map(c => [
    c.name,
    c.email || "",
    c.phone || "",
    c.orders,
    c.totalSpent
  ]);

  let csvContent =
    "data:text/csv;charset=utf-8," +
    [headers, ...rows].map(e => e.join(",")).join("\n");

  const link = document.createElement("a");
  link.href = encodeURI(csvContent);
  link.download = "customers.csv";
  link.click();
};

const exportExcel = (data) => {
  const formatted = data.map(c => ({
    Name: c.name,
    Email: c.email || "",
    Phone: c.phone || "",
    Orders: c.orders,
    Spent: c.totalSpent,
  }));

  const ws = XLSX.utils.json_to_sheet(formatted);
  const wb = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(wb, ws, "Customers");
  XLSX.writeFile(wb, "customers.xlsx");
};

const exportPDF = (data) => {
  const doc = new jsPDF();

  const rows = data.map(c => [
    c.name,
    c.email || "",
    c.phone || "",
    c.orders,
    `$${c.totalSpent}`
  ]);

  autoTable(doc, {
    head: [["Name", "Email", "Phone", "Orders", "Spent"]],
    body: rows,
  });

  doc.save("customers.pdf");
};

const handlePrint = (ref) => {
  if (!ref?.current) return;

  const content = ref.current.innerHTML;

  const printWindow = window.open("", "", "width=900,height=650");

  printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body {
            font-family: Arial;
            padding: 20px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
          }
          th, td {
            border: 1px solid #ddd;
            padding: 8px;
          }
          th {
            background: #f5f5f5;
          }
        </style>
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
};
    
    const printList = () => {
  window.print();
};


    const TEXT = {
        EN: {
            title: "Customers",
            search: "Search customers...",
            name: "Name",
            email: "Email",
            phone: "Phone",
            orders: "Orders",
            whatsappContacts: "WhatsApp Contacts",
            totalSpent: "Total Spent",
            lastOrder: "Last Order",
            exportEmails: "Export Emails",
            status: "Status",
            actions: "Actions",
            loading: "Loading customers...",
            empty: "No customers found.",
            view: "View",
            toggle: "Toggle",
            totalCustomers: "Total customers",
            sendWhatsapp: "Send WhatsApp Message",
            noPhones: "No customers with phone numbers",
            reset: "Reset",
            print: "Print",
csv: "CSV",
excel: "Excel",
pdf: "PDF",
close: "Close",
            today: "Today",
            thisWeek: "This Week",
            thisMonth: "This Month",
            weekDays: ["Su","Mo","Tu","We","Th","Fr","Sa"],
        },
        AR: {
            title: "العملاء",
            print: "طباعة",
csv: "CSV",
excel: "Excel",
pdf: "PDF",
close: "إغلاق",
            search: "ابحث عن العملاء...",
            name: "الاسم",
            email: "البريد الإلكتروني",
            phone: "الهاتف",
            orders: "الطلبات",
            totalSpent: "إجمالي الإنفاق",
            lastOrder: "آخر طلب",
            status: "الحالة",
            actions: "الإجراءات",
            exportEmails: "تصدير الإيميلات",
            whatsappContacts: "جهات اتصال واتساب",
            loading: "جاري تحميل العملاء...",
            empty: "لا يوجد عملاء.",
            view: "عرض",
            toggle: "تغيير الحالة",
            totalCustomers: "إجمالي العملاء",
            sendWhatsapp: "إرسال رسالة واتساب",
            noPhones: "لا يوجد عملاء لديهم أرقام هاتف",
            reset: "إعادة تعيين",
            today: "اليوم",
            thisWeek: "هذا الأسبوع",
            thisMonth: "هذا الشهر",
            reset: "إعادة تعيين",
            weekDays: ["أحد","اثنين","ثلثاء","اربعاء","خميس","جمعة","سبت"],
        },
    }[lang];

    const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
const perms = JSON.parse(localStorage.getItem("staffPermissions") || "{}");
const isAdmin = adminUser.role === "admin";

const canAccess = isAdmin || perms.can_manage_customers;

useEffect(() => {
  goToCustomersPage(1);
}, [search, dateFrom, dateTo]);

useEffect(() => {
  const handleClick = (e) => {
    if (
      !e.target.closest(".sort-overlay") &&
      !e.target.closest(".sort-button")
    ) {
      setSortOpen(false);
    }
  };

  if (sortOpen) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [sortOpen]);

useEffect(() => {
  goToCustomersPage(1);
}, [search, dateFrom, dateTo]);

    useEffect(() => {
  setLoading(true);

  getAdminCustomers()
    .then(setCustomers)
    .catch(console.error)
    .finally(() => setLoading(false));
}, []);

const CalendarRangePicker = ({ rangeStart, rangeEnd, setRangeStart, setRangeEnd }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const startOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
  const endOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);

  const startDay = startOfMonth.getDay();

  const days = [];

  for (let i = 0; i < startDay; i++) {
    days.push(null);
  }

  for (let d = 1; d <= endOfMonth.getDate(); d++) {
    days.push(new Date(currentMonth.getFullYear(), currentMonth.getMonth(), d));
  }

  const isSameDay = (a, b) =>
    a && b &&
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  const isInRange = (day) => {
    if (!rangeStart || !rangeEnd) return false;
    return day >= rangeStart && day <= rangeEnd;
  };

  const handleClick = (day) => {
    if (!rangeStart || (rangeStart && rangeEnd)) {
      setRangeStart(day);
      setRangeEnd(null);
    } else {
      if (day < rangeStart) {
        setRangeEnd(rangeStart);
        setRangeStart(day);
      } else {
        setRangeEnd(day);
      }
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-3 px-2">
        <button onClick={() => setCurrentMonth(new Date(currentMonth.setMonth(currentMonth.getMonth() - 1)))}>‹</button>

        <div className="font-semibold text-sm">
          {currentMonth.toLocaleString(lang === "AR" ? "ar" : "en", {
            month: "long",
            year: "numeric",
          })}
        </div>

        <button onClick={() => setCurrentMonth(new Date(currentMonth.setMonth(currentMonth.getMonth() + 1)))}>›</button>
      </div>

      <div className="grid grid-cols-7 text-xs text-gray-500 mb-2 px-2">
        {TEXT.weekDays.map(d => (
          <div key={d} className="text-center">{d}</div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-1">
        {days.map((day, i) => {
          if (!day) return <div key={i} />;

          const selected = isSameDay(day, rangeStart) || isSameDay(day, rangeEnd);
          const inRange = isInRange(day);

          return (
            <button
              key={i}
              onClick={() => handleClick(day)}
              className={`
                h-8 rounded-md text-sm
                ${selected ? "bg-black text-white" : ""}
                ${inRange && !selected ? "bg-gray-200" : ""}
                hover:bg-gray-300
              `}
            >
              {day.getDate()}
            </button>
          );
        })}
      </div>
    </div>
  );
};

    const q = search.toLowerCase();

    const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const confirmDelete = async () => {
  try {
    await deleteAdminCustomer(deleteId);

    setCustomers((prev) =>
      prev.filter((c) => c.id !== deleteId)
    );

    setToast({
      type: "success",
      message: lang === "AR"
        ? "تم حذف العميل"
        : "Customer deleted",
    });

  } catch (e) {
    alert(e.message);
  } finally {
    setDeleteId(null);
  }
};

const confirmBulkDelete = async () => {
  try {
    await Promise.all(
      selectedCustomers.map((id) => deleteAdminCustomer(id))
    );

    setCustomers((prev) =>
      prev.filter((c) => !selectedCustomers.includes(c.id))
    );

    setSelectedCustomers([]);

    setToast({
      type: "success",
      message: lang === "AR"
        ? "تم حذف العملاء"
        : "Customers deleted",
    });

  } catch (e) {
    alert(e.message);
  } finally {
    setDeleteId(null);
  }
};

const toggleCustomerSelection = (id) => {
  setSelectedCustomers((prev) =>
    prev.includes(id)
      ? prev.filter((c) => c !== id)
      : [...prev, id]
  );
};

const toggleSelectAll = () => {
  if (selectedCustomers.length === paginated.length) {
    setSelectedCustomers([]);
  } else {
    setSelectedCustomers(paginated.map((c) => c.id));
  }
};

const filtered = customers.filter((c) => {
  // 🔍 search
  const matchesSearch =
    (c.name || "").toLowerCase().includes(q) ||
    (c.email || "").toLowerCase().includes(q) ||
    (c.phone || "").toLowerCase().includes(q);

  if (!matchesSearch) return false;

  // ✅ STATUS FILTER (FIX)
  if (statusFilter !== "all" && c.status !== statusFilter) {
    return false;
  }

  // 📅 date filter
  if (dateFrom || dateTo) {
    const raw = c.created_at ?? c.createdAt;
    if (!raw) return false;

    const d = raw instanceof Date ? raw : new Date(raw);
    if (isNaN(d.getTime())) return false;

    const createdYMD =
      d.getFullYear() +
      "-" +
      String(d.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(d.getDate()).padStart(2, "0");

    if (dateFrom && createdYMD < dateFrom) return false;
    if (dateTo && createdYMD > dateTo) return false;
  }

  return true;
});

const totalPages = Math.ceil(filtered.length / perPage);
const currentPage = Math.min(page, totalPages || 1);

const sorted = [...filtered].sort((a, b) => {
  if (!sortBy) return 0;

  let vA = a[sortBy];
  let vB = b[sortBy];

  if (sortBy === "created_at") {
    vA = new Date(vA);
    vB = new Date(vB);
  }

  if (sortDirection === "asc") return vA > vB ? 1 : -1;
  return vA < vB ? 1 : -1;
});

const paginated = sorted.slice(
  (currentPage - 1) * perPage,
  currentPage * perPage
);


  const toggleStatus = async (id) => {
  await toggleAdminCustomerStatus(id);

  let newStatus = null;

  setCustomers((prev) =>
    prev.map((c) => {
      if (c.id === id) {
        newStatus = c.status === "active" ? "blocked" : "active";
        return { ...c, status: newStatus };
      }
      return c;
    })
  );

  // ✅ SHOW TOAST
  setToast({
    type: "success",
    message:
      lang === "AR"
        ? newStatus === "active"
          ? "تم تفعيل العميل"
          : "تم حظر العميل"
        : newStatus === "active"
        ? "Customer activated"
        : "Customer blocked",
  });

  // auto hide
  setTimeout(() => setToast(null), 2500);
};

const applyQuickDateFilter = (type) => {
  const today = new Date();

  const toYMD = (d) =>
    d.getFullYear() +
    "-" +
    String(d.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(d.getDate()).padStart(2, "0");

  if (type === "today") {
    const ymd = toYMD(today);
    setDateFrom(ymd);
    setDateTo(ymd);
  }

  if (type === "week") {
    const start = new Date(today);
    start.setDate(today.getDate() - 6); // last 7 days
    setDateFrom(toYMD(start));
    setDateTo(toYMD(today));
  }

  if (type === "month") {
    const start = new Date(today.getFullYear(), today.getMonth(), 1);
    setDateFrom(toYMD(start));
    setDateTo(toYMD(today));
  }
};

const resetFilters = () => {
  setSearch("");
  setDateFrom("");
  setDateTo("");
};

const sendWhatsappMessage = () => {
  const phones = filtered
    .map(c => c.phone)
    .filter(Boolean)
    .map(p => p.replace(/[^\d]/g, ""));

  if (phones.length === 0) {
    alert(TEXT.noPhones);
    return;
  }

  // ✅ COPY ALL NUMBERS (comma-separated) for WhatsApp Broadcast
  navigator.clipboard.writeText(phones.join(","));

  // ✅ Use admin-written message from modal
  const message = encodeURIComponent(
    whatsappMessage || "Hello 👋"
  );

  // ✅ Open WhatsApp Business
  window.location.href = `whatsapp://send?text=${message}`;
};

const sendEmailMessage = () => {
  const emails = filtered
    .map(c => c.email)
    .filter(Boolean);

  if (emails.length === 0) {
    alert(lang === "AR" ? "لا يوجد بريد إلكتروني" : "No customer emails found");
    return;
  }

  // ✅ Copy emails for backup / reuse
  navigator.clipboard.writeText(emails.join(","));

  const subject = encodeURIComponent(emailSubject || "Our Latest Updates");
  const body = encodeURIComponent(emailMessage || "Hello 👋");

  // ✅ BCC = all customers
  const mailto = `mailto:?bcc=${emails.join(",")}&subject=${subject}&body=${body}`;

  window.location.href = mailto;
};

const openCommunityEmails = async () => {
  try {
    const data = await getCommunityEmails();
    setCommunityEmails(data);
    setCommunityPage(1);
    setCommunityOpen(true);
  } catch (e) {
    alert(lang === "AR" ? "فشل تحميل الإيميلات" : "Failed to load emails");
  }
};


const sendCommunityEmails = () => {
  if (communityEmails.length === 0) {
    alert(lang === "AR" ? "لا يوجد إيميلات" : "No community emails");
    return;
  }

  const emails = communityEmails.map(e => e.email);

  const subject = encodeURIComponent(
    communityEmailSubject || "Community Updates"
  );

  const body = encodeURIComponent(
    communityEmailMessage || "Hello 👋"
  );

  // optional copy for backup
  navigator.clipboard.writeText(emails.join(","));

  const mailto = `mailto:?bcc=${emails.join(",")}&subject=${subject}&body=${body}`;
  window.location.href = mailto;

  // cleanup
  setCommunityEmailOpen(false);
  setCommunityEmailSubject("");
  setCommunityEmailMessage("");
};

const hasCustomDate = Boolean(dateFrom || dateTo);

// EMAIL MODAL DATA
const emailModalData = filtered.filter(c => c.email);

// WHATSAPP MODAL DATA
const phoneModalData = filtered.filter(c => c.phone);

// COMMUNITY MODAL DATA (already correct)
const communityModalData = communityEmails;

    return (
        <div className={`flex bg-[#f1f1f1] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
            <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

            <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""} w-full transition-all duration-300`}>
                <AdminHeader setIsOpen={setIsOpen} />

                <main className="p-4 sm:p-6 animate-fadeSlide">
  {!canAccess && (
    <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
      <p className="text-red-700 font-semibold">
        {lang === "AR"
          ? "ليس لديك صلاحية للوصول إلى هذه الصفحة"
          : "You do not have permission to access this page."}
      </p>
    </div>
  )}

  {canAccess && (
    <>

                <div className="print:hidden">
                    {/* ===== TITLE ROW ===== */}
<div className="flex items-center justify-between mb-5">
  <div className="flex items-center gap-2">
    <div className="flex items-center justify-center w-6 h-6">
      <FaUserShield className="text-gray-900 text-[18px]" />
    </div>

    <h1 className="text-[20px] font-semibold text-gray-900">
      {TEXT.title}
    </h1>
  </div>

  <button
  onClick={() => navigate("/admin/customers/add")}
  className="
    h-8 px-3
    bg-[#1f1f1f]
    text-white
    rounded-lg
    shadow-[0_1px_0_rgba(0,0,0,0.08),0_3px_8px_rgba(0,0,0,0.2)]
    text-sm font-medium
    hover:bg-black
    active:shadow-[inset_0_2px_6px_rgba(0,0,0,0.3)]
    transition
    flex items-center gap-2
  "
>
  {lang === "AR" ? "إضافة عميل" : "Add Customer"}
</button>
</div>


                    {/* DESKTOP TABLE */}
                    <div className="
  hidden md:block
  bg-white
  border border-[#e3e3e3]
  rounded-[14px]
  overflow-visible
  shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
">
                        <div className="overflow-x-auto">
<div className="relative flex items-center justify-between px-4 py-3 border-b border-[#e3e3e3] bg-white rounded-t-[14px]">

{/* ================= SORT OVERLAY ================= */}
{sortOpen && (
  <div
  className="sort-overlay fixed w-56 bg-white border border-gray-200 rounded-xl shadow-[0_30px_30px_rgba(0,0,0,0.15)] z-[9999] animate-sortOverlay"
  style={{
  top: "120px",
  ...(lang === "AR"
    ? { left: "40px" }
    : { right: "40px" })
}}
>

    <div className="px-4 pt-4 text-xs font-semibold uppercase tracking-wide">
      {lang === "AR" ? "ترتيب حسب" : "Sort by"}
    </div>

    <div className="mt-1 text-sm">

      {[
        { label: TEXT.name, value: "name" },
        { label: TEXT.email, value: "email" },
        { label: TEXT.totalSpent, value: "totalSpent" },
        { label: TEXT.lastOrder, value: "created_at" },
      ].map(opt => (
        <label
          key={opt.value}
          className={`flex items-center gap-3 px-3 py-2 cursor-pointer rounded-md hover:bg-gray-100 ${
            sortField === opt.value ? "bg-gray-100 font-medium" : ""
          }`}
        >
          <input
            type="radio"
            checked={sortField === opt.value}
            onChange={() => setSortField(opt.value)}
            className="w-4 h-4 accent-gray-800"
          />
          {opt.label}
        </label>
      ))}

    </div>

    <div className="border-t my-2"></div>

    <button
      onClick={() => {
        setSortBy(sortField);
        setSortDirection("asc");
        setSortOpen(false);
      }}
      className="px-3 py-2 text-sm w-full text-left hover:bg-gray-100"
    >
      ↑ {lang === "AR" ? "تصاعدي" : "Ascending"}
    </button>

    <button
      onClick={() => {
        setSortBy(sortField);
        setSortDirection("desc");
        setSortOpen(false);
      }}
      className="px-3 py-2 text-sm w-full text-left hover:bg-gray-100"
    >
      ↓ {lang === "AR" ? "تنازلي" : "Descending"}
    </button>

    {/* DATE */}
    {sortField === "created_at" && (
  hasCustomDate ? (
    <button
      onClick={() => {
        setDateFrom("");
        setDateTo("");
        setDateOverlayOpen(false);
        setSortOpen(false);
      }}
      className="px-3 py-2 text-sm w-full text-left hover:bg-gray-100"
    >
      ↺ {lang === "AR" ? "إعادة تعيين التاريخ" : "Reset date"}
    </button>
  ) : (
    <button
      onClick={() => {
        setDateOverlayOpen(true);
        setSortOpen(false);
      }}
      className="px-3 py-2 text-sm w-full text-left hover:bg-gray-100"
    >
      <div className="flex items-center gap-2">
  <FiCalendar className="text-gray-600 text-[14px]" />
  {lang === "AR" ? "تاريخ مخصص" : "Custom date"}
</div>
    </button>
  )
)}
  </div>
)}

{/* ================= LEFT BUTTONS ================= */}
<div className="flex items-center gap-1">

  {/* EMAIL LIST */}
  <button
    onClick={() => setEmailOpen(true)}
    className="
    group
    flex items-center justify-center
    w-9 h-9
    bg-white border border-gray-300 rounded-lg
    shadow-sm
    hover:bg-gray-50 hover:border-gray-400
    transition
    "
    title={lang === "AR" ? "الإيميلات" : "Emails"}
  >
    <FiMail className="text-gray-600 group-hover:text-black text-[15px]" />
  </button>

  {/* PHONE LIST */}
  <button
    onClick={() => setWhatsappOpen(true)}
    className="
    group
    flex items-center justify-center
    w-9 h-9
    bg-white border border-gray-300 rounded-lg
    shadow-sm
    hover:bg-gray-50 hover:border-gray-400
    transition
    "
    title={lang === "AR" ? "الأرقام" : "Phones"}
  >
    <FiPhone className="text-gray-600 group-hover:text-black text-[15px]" />
  </button>

  {/* COMMUNITY */}
  <button
    onClick={openCommunityEmails}
    className="
    group
    flex items-center justify-center
    w-9 h-9
    bg-white border border-gray-300 rounded-lg
    shadow-sm
    hover:bg-gray-50 hover:border-gray-400
    transition
    "
    title={lang === "AR" ? "المجتمع" : "Community"}
  >
    <FiUsers className="text-gray-600 group-hover:text-black text-[15px]" />
  </button>

</div>

{/* ================= RIGHT SIDE ================= */}
<div className="flex items-center gap-2">

{selectedCustomers.length > 0 && (
  <button
    onClick={() => setDeleteId("bulk")}
    className="
    flex items-center justify-center
    w-9 h-9
    bg-white
    border border-gray-300
    rounded-lg
    shadow-sm
    hover:bg-gray-50
    transition
    "
  >
    <FaTrash className="text-gray-600 text-sm" />
  </button>
)}

  {/* SEARCH */}
  {!searchOpen ? (
    <button
      onClick={() => setSearchOpen(true)}
      className="
      flex items-center justify-center gap-1
      w-9 h-9
      bg-white border border-gray-300 rounded-lg
      shadow-sm hover:bg-gray-50 transition
      "
    >
      <FaSearch className="text-gray-600 text-sm" />
    </button>
  ) : (
    <div className="flex items-center gap-3">

      <div className="flex items-center h-9 px-3 bg-white border border-gray-300 rounded-lg shadow-sm">

        <FaSearch className="text-gray-400 text-sm" />

        <input
          autoFocus
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={TEXT.search}
          className="ml-2 outline-none text-sm"
        />

        <button
          onClick={() => {
            setSearch("");
            setSearchOpen(false);
          }}
          className="ml-2 text-gray-400"
        >
          ✕
        </button>
      </div>

      <button
  onClick={() => {
    setSearch("");
    setSearchOpen(false);
  }}
  className="
  h-9 px-4
  bg-white border border-gray-300
  rounded-lg
  text-sm
  hover:bg-gray-50
  "
>
  {lang === "AR" ? "إلغاء" : "Cancel"}
</button>

    </div>
  )}

  {/* SORT BUTTON */}
  <button
  onClick={() => setSortOpen(v => !v)}
  className="
  sort-button
  flex items-center justify-center
  w-9 h-9 text-gray-600
  bg-white border border-gray-300 rounded-lg
  shadow-sm hover:bg-gray-50 transition
"
>
    ⇅
  </button>

</div>

</div>
                            <table
  dir={lang === "AR" ? "rtl" : "ltr"}
  className="min-w-[800px] lg:min-w-[900px] w-full"
>
                                <thead className="bg-[#f6f6f7] text-[#6d7175] text-[13px] font-medium">
                                    <tr>
                                      <th className="p-3 text-center">
  <input
    type="checkbox"
    checked={
      selectedCustomers.length === paginated.length &&
      paginated.length > 0
    }
    onChange={toggleSelectAll}
    className="w-4 h-4 accent-gray-800 cursor-pointer"
  />
</th>
                                        <th className="p-3 text-center">
  {lang === "AR" ? "اسم العميل" : "Customer name"}
</th>
                                        <th className="p-3 text-center">
  {lang === "AR" ? "الاشتراك بالبريد" : "Email subscription"}
</th>
                                        <th className="p-3 text-center">{TEXT.phone}</th>
                                        <th className="p-3 text-center">{TEXT.orders}</th>
                                        <th className="p-3 text-center">
  {lang === "AR" ? "المبلغ المنفق" : "Amount spent"}
</th>
                                        <th className="p-3 text-center">{TEXT.lastOrder}</th>
                                        <th className="p-3 text-center">{TEXT.status}</th>
                                        <th className="p-3 text-center">{TEXT.actions}</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {loading ? (
  [...Array(6)].map((_, i) => (
    <tr key={i} className="animate-pulse border-b">
      {[...Array(9)].map((_, j) => (
        <td key={j} className="p-3">
          <div className="h-3 bg-gray-200 rounded w-3/4 mx-auto"></div>
        </td>
      ))}
    </tr>
  ))
) : filtered.length === 0 ? (
                                        <tr>
                                            <td colSpan="9" className="py-12 text-center">
  <div className="flex flex-col items-center gap-2 text-gray-500">
    <FaInbox className="text-2xl opacity-60" />
    <p className="text-sm font-medium">{TEXT.empty}</p>
  </div>
</td>
                                        </tr>
                                    ) : (
                                        paginated.map((c) => (
                                      <tr
  key={c.id}
  onClick={() => navigate(`/admin/customers/${c.id}`)}
  className="
    group
    border-b border-[#f1f1f1]
    hover:bg-[#f6f6f7]
    transition
    text-[13px]
    cursor-pointer
  "
>
  <td
  className="p-3 text-center"
  onClick={(e) => e.stopPropagation()}
>
  <input
    type="checkbox"
    checked={selectedCustomers.includes(c.id)}
    onChange={() => toggleCustomerSelection(c.id)}
    className="w-4 h-4 accent-gray-800 cursor-pointer"
  />
</td>

                                                <td className="py-1 px-3 font-semibold text-center">{c.name}</td>
                                               <td className="py-1 px-3 text-center">
  {c.email ? (
    c.email
  ) : (
    <span className="inline-flex items-center px-2 py-[2px] rounded-md text-[11px] font-medium bg-gray-100 text-gray-600">
      {lang === "AR" ? "غير مشترك" : "Not subscribed"}
    </span>
  )}
</td>
                                                <td className="py-1 px-3 text-center">{c.phone}</td>
                                                <td className="py-1 px-3 text-center">{c.orders}</td>

                                                <td className="py-1 px-3 text-center font-bold text-green-700">
                                                   {lang === "AR" ? `${c.totalSpent}$` : `$${c.totalSpent}`}
                                                </td>

                                                <td className="py-1 px-3 text-center">{c.lastOrder}</td>

                                                <td className="py-1 px-3 text-center">
                                                    <span
                                                        className={`px-3 py-1 rounded-full text-sm font-semibold ${
                                                            c.status === "active"
                                                                ? "bg-green-50 text-green-700"
                                                                : "bg-red-50 text-red-700"
                                                        }`}
                                                    >
                                                       {
  c.status === "active"
    ? (lang === "AR" ? "نشط" : "Active")
    : (lang === "AR" ? "محظور" : "Blocked")
}
                                                    </span>
                                                </td>

                                                <td className="py-1 px-3 text-center flex items-center justify-center gap-3">
                                                    <button
                                                        className="w-8 h-8 flex items-center justify-center rounded-md bg-white border border-gray-300 shadow-sm hover:bg-gray-50"
                                                        onClick={(e) => {
    e.stopPropagation();
    navigate(`/admin/customers/${c.id}`);
  }}
                                                    >
                                                        <FaEye />
                                                    </button>

                                                    <button
                                                        className={`${
                                                            c.status === "active"
                                                                ? "text-yellow-600 hover:text-yellow-800"
                                                                : "text-green-600 hover:text-green-800"
                                                        }`}
                                                        onClick={(e) => {
    e.stopPropagation();
    toggleStatus(c.id);
  }}
                                                    >
                                                        {c.status === "active" ? (
                                                            <FaUserSlash />
                                                        ) : (
                                                            <FaUserShield />
                                                        )}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                                <tfoot>
  <tr className="bg-[#f6f6f7] border-t border-[#e3e3e3]">
    <td colSpan="9" className="px-4 py-2 rounded-b-[14px]">

      <div className="flex items-center justify-between text-sm text-gray-600">

        {/* COUNT */}
        <span className="text-gray-500 text-sm">
  {filtered.length} {lang === "AR" ? "عميل" : "customers"}
</span>

        {/* PAGINATION */}
        <div className="flex items-center gap-0.5">

          <button
            onClick={() => goToCustomersPage(p => Math.max(1, p - 1))}
            disabled={currentPage === 1}
            className={`w-7 h-7 flex font-bold items-center justify-center rounded-md border bg-gray-200 ${
              currentPage === 1
                ? "opacity-40 cursor-not-allowed"
                : "hover:bg-gray-300"
            }`}
          >
            {"<"}
          </button>

          <button
            onClick={() => goToCustomersPage(p => Math.min(totalPages || 1, p + 1))}
            disabled={currentPage === totalPages || totalPages === 0}
            className={`w-7 h-7 flex items-center font-bold justify-center rounded-md border bg-gray-200 ${
              currentPage === totalPages || totalPages === 0
                ? "opacity-40 cursor-not-allowed"
                : "hover:bg-gray-300"
            }`}
          >
            {">"}
          </button>

          <span className="mx-2 text-gray-600 font-bold">
            {currentPage}-{totalPages || 1}
          </span>

        </div>
      </div>

    </td>
  </tr>
</tfoot>
                            </table>
                        </div>
                    </div>

                    {/* MOBILE VIEW */}
                   <div className="md:hidden">
                    <div className="bg-white border border-gray-200 rounded-xl p-3 mb-3 shadow-sm space-y-3">

  {/* SEARCH */}
  <div className="flex items-center gap-2 border rounded-lg px-3 h-10">
    <FaSearch className="text-gray-400 text-sm" />
    <input
      type="text"
      value={search}
      onChange={(e) => {
        setSearch(e.target.value);
        goToCustomersPage(1);
      }}
      placeholder={TEXT.search}
      className="flex-1 outline-none text-sm bg-transparent"
    />
  </div>

  {/* QUICK FILTERS (Shopify style) */}
  <div className="flex items-center gap-2 flex-wrap">

    {[
      { label: lang === "AR" ? "الكل" : "All", value: "all" },
      { label: lang === "AR" ? "نشط" : "Active", value: "active" },
      { label: lang === "AR" ? "محظور" : "Blocked", value: "blocked" },
    ].map((f) => {

      const active = statusFilter === f.value;
      
      return (
        <button
          key={f.value}
          onClick={() => {
            setStatusFilter(f.value);
            goToCustomersPage(1);
          }}
          className={`px-3 py-1 text-xs rounded-md transition ${
            active
              ? "bg-gray-900 text-white"
              : "bg-gray-100 text-gray-900"
          }`}
        >
          {f.label}
        </button>
      );
    })}

  </div>

  {/* DATE QUICK FILTERS */}
  <div className="flex items-center gap-2 flex-wrap">

    <button
      onClick={() => applyQuickDateFilter("today")}
      className="px-3 py-1 text-xs rounded-md bg-gray-100 hover:bg-gray-200"
    >
      {TEXT.today}
    </button>

    <button
      onClick={() => applyQuickDateFilter("week")}
      className="px-3 py-1 text-xs rounded-md bg-gray-100 hover:bg-gray-200"
    >
      {TEXT.thisWeek}
    </button>

    <button
      onClick={() => applyQuickDateFilter("month")}
      className="px-3 py-1 text-xs rounded-md bg-gray-100 hover:bg-gray-200"
    >
      {TEXT.thisMonth}
    </button>

    <button
      onClick={resetFilters}
      className="px-3 py-1 text-xs rounded-md bg-red-50 text-red-600"
    >
      {TEXT.reset}
    </button>

  </div>

  {/* COUNT */}
  <div className="text-xs text-gray-500">
    {filtered.length} {lang === "AR" ? "عميل" : "customers"}
  </div>

</div>
                       {loading ? (
  [...Array(4)].map((_, i) => (
    <div key={i} className="bg-white p-4 rounded-xl shadow animate-pulse space-y-3 mb-3">
      <div className="h-4 bg-gray-200 rounded w-1/2"></div>
      <div className="h-3 bg-gray-200 rounded w-3/4"></div>
      <div className="h-3 bg-gray-200 rounded w-2/3"></div>
    </div>
  ))
) : filtered.length === 0 ? (
                            <div className="bg-white p-6 rounded-xl shadow text-center">
  <div className="flex flex-col items-center gap-2 text-gray-500">
    <FaInbox className="text-2xl opacity-60" />
    <p className="text-sm font-medium">{TEXT.empty}</p>
  </div>
</div>
                        ) : (
                            paginated.map((c) => (
                                <div
  key={c.id}
  onClick={() => navigate(`/admin/customers/${c.id}`)}
  className="
    bg-white
    border border-[#e3e3e3]
    rounded-[14px]
    shadow-[0_8px_20px_rgba(0,0,0,0.08)]
    p-4
    space-y-3
    mb-3
    active:scale-[0.99]
    transition
    cursor-pointer
  "
>
{/* TOP */}
<div className="flex items-start justify-between gap-3">
  <div className="flex items-center gap-3">
    
    {/* Avatar */}
    <div className="w-11 h-11 rounded-full bg-gray-200 flex items-center justify-center text-gray-900 font-semibold uppercase">
      {(c.name || "U").charAt(0)}
    </div>

    {/* Name + email */}
    <div>
      <div className="font-semibold text-gray-900">
        {c.name}
      </div>
      <div className="text-xs text-gray-500 mt-0.5">
        {c.email || "—"}
      </div>
    </div>
  </div>

  {/* Status badge */}
  <span
    className={`inline-flex items-center justify-center px-2.5 py-[2px] rounded-md text-[11px] font-medium ${
      c.status === "active"
        ? "bg-green-50 text-green-700"
        : "bg-red-50 text-red-700"
    }`}
  >
    {c.status === "active"
      ? (lang === "AR" ? "نشط" : "Active")
      : (lang === "AR" ? "محظور" : "Blocked")}
  </span>
</div>

{/* INFO ROWS */}
<div className="flex items-center justify-between text-sm">
  <span className="text-gray-500">{TEXT.phone}</span>
  <span className="text-gray-900">{c.phone || "—"}</span>
</div>

<div className="flex items-center justify-between text-sm">
  <span className="text-gray-500">{TEXT.orders}</span>
  <span className="text-gray-900 font-medium">{c.orders}</span>
</div>

<div className="flex items-center justify-between text-sm">
  <span className="text-gray-500">{TEXT.totalSpent}</span>
  <span className="text-green-700 font-semibold">
    ${c.totalSpent}
  </span>
</div>

<div className="flex items-center justify-between text-sm">
  <span className="text-gray-500">{TEXT.lastOrder}</span>
  <span className="text-gray-900">{c.lastOrder || "—"}</span>
</div>

{/* ACTIONS */}
<div className="flex items-center justify-end gap-2 pt-2 border-t">
  <button
  onClick={(e) => {
    e.stopPropagation();
    setDeleteId(c.id);
  }}
  className="
    w-9 h-9 flex items-center justify-center
    rounded-md
    bg-white border border-gray-300
    shadow-sm hover:bg-gray-50 transition
  "
>
  <FaTrash className="text-red-600 text-[13px]" />
</button>
  <button
    onClick={(e) => {
      e.stopPropagation();
      navigate(`/admin/customers/${c.id}`);
    }}
    className="
      w-9 h-9 flex items-center justify-center
      rounded-md
      bg-white border border-gray-300
      shadow-sm hover:bg-gray-50 transition
    "
  >
    <FaEye className="text-gray-900 text-[13px]" />
  </button>

  <button
    onClick={(e) => {
      e.stopPropagation();
      toggleStatus(c.id);
    }}
    className="
      w-9 h-9 flex items-center justify-center
      rounded-md
      bg-white border border-gray-300
      shadow-sm hover:bg-gray-50 transition
    "
  >
    {c.status === "active" ? (
      <FaUserSlash className="text-orange-600 text-[14px]" />
    ) : (
      <FaUserShield className="text-green-600 text-[14px]" />
    )}
  </button>
</div>
                                </div>
                            ))
                        )}
                        {!loading && filtered.length > 0 && (
  <div className="sticky bottom-0 bg-white border-t p-3 flex items-center justify-between text-sm">

  <span className="text-xs text-gray-500">
    {currentPage} / {totalPages || 1}
  </span>

  <div className="flex items-center gap-2">

    <button
      onClick={() => goToCustomersPage(p => Math.max(1, p - 1))}
      disabled={currentPage === 1}
      className="px-3 py-1.5 rounded-md border bg-white disabled:opacity-40"
    >
      {lang === "AR" ? "السابق" : "Prev"}
    </button>

    <button
      onClick={() => goToCustomersPage(p => Math.min(totalPages || 1, p + 1))}
      disabled={currentPage === totalPages || totalPages === 0}
      className="px-3 py-1.5 rounded-md border bg-white disabled:opacity-40"
    >
      {lang === "AR" ? "التالي" : "Next"}
    </button>

  </div>
</div>
)}
                    </div>


   {emailOpen && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">

    <div className="bg-white rounded-lg shadow-xl w-[90%] max-w-4xl max-h-[90vh] overflow-auto p-6">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">
          {lang === "AR" ? "تصدير الإيميلات" : "Export Emails"}
        </h2>

        <div className="flex gap-2 flex-wrap">

          <button onClick={() => handlePrint(emailPrintRef)} className="px-3 py-1 bg-black text-white rounded">
            {TEXT.print}
          </button>

          <button onClick={() => exportCSV(emailModalData)} className="px-3 py-1 border rounded">
            CSV
          </button>

          <button onClick={() => exportExcel(emailModalData)} className="px-3 py-1 border rounded">
            Excel
          </button>

          <button onClick={() => exportPDF(emailModalData)} className="px-3 py-1 border rounded">
            PDF
          </button>

          <button onClick={() => setEmailOpen(false)} className="px-3 py-1 border rounded">
             {TEXT.close}
          </button>

        </div>
      </div>

      {/* TABLE */}
      <div ref={emailPrintRef} id="print-area">
        <table className="w-full text-sm border">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">{TEXT.name}</th>
              <th className="p-2 border">{TEXT.email}</th>
            </tr>
          </thead>

          <tbody>
            {filtered
              .filter(c => c.email)
              .map(c => (
                <tr key={c.id}>
                  <td className="p-2 border">{c.name}</td>
                  <td className="p-2 border">{c.email}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

    </div>
  </div>
)}

{communityOpen && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">

    <div className="bg-white rounded-lg shadow-xl w-[90%] max-w-4xl max-h-[90vh] overflow-auto p-6">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">
          {lang === "AR" ? "تصدير إيميلات المجتمع" : "Export Community Emails"}
        </h2>

        <div className="flex gap-2 flex-wrap">

          <button
            onClick={() => handlePrint(communityPrintRef)}
            className="px-3 py-1 bg-black text-white rounded"
          >
            {TEXT.print}
          </button>

          <button
            onClick={() => exportCSV(communityModalData)}
            className="px-3 py-1 border rounded"
          >
            CSV
          </button>

          <button
            onClick={() => exportExcel(communityEmails)}
            className="px-3 py-1 border rounded"
          >
            Excel
          </button>

          <button
            onClick={() => exportPDF(communityEmails)}
            className="px-3 py-1 border rounded"
          >
            PDF
          </button>

          <button
            onClick={() => setCommunityOpen(false)}
            className="px-3 py-1 border rounded"
          >
            {TEXT.close}
          </button>

        </div>
      </div>

      {/* TABLE (IMPORTANT FOR PRINT) */}
      <div ref={communityPrintRef} id="print-area">
        <table className="w-full text-sm border">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">
                {lang === "AR" ? "البريد الإلكتروني" : "Email"}
              </th>
              <th className="p-2 border">
                {lang === "AR" ? "تاريخ الاشتراك" : "Joined At"}
              </th>
            </tr>
          </thead>

          <tbody>
            {communityEmails.map((e) => (
              <tr key={e.id}>
                <td className="p-2 border">{e.email}</td>
                <td className="p-2 border">
                  {new Date(e.created_at).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  </div>
)}


                    {communityEmailOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="
w-full max-w-lg
bg-white
border border-gray-200
rounded-[14px]
shadow-[0_20px_40px_rgba(0,0,0,0.12)]
overflow-hidden
">

      <div className="px-5 py-4 border-b bg-[#f6f6f7]">
  <h3 className="text-[15px] font-semibold text-gray-800">
        {lang === "AR"
          ? "إرسال بريد إلى مجتمع المشتركين"
          : "Send Email to Community"}
      </h3>
      </div>

      <input
        value={communityEmailSubject}
        onChange={(e) => setCommunityEmailSubject(e.target.value)}
        placeholder={lang === "AR" ? "عنوان الرسالة" : "Email subject"}
        className="
w-full
h-9
px-3
border border-gray-300
rounded-lg
bg-white
text-sm
focus:outline-none focus:ring-2 focus:ring-gray-300
"
      />

      <textarea
        rows="6"
        value={communityEmailMessage}
        onChange={(e) => setCommunityEmailMessage(e.target.value)}
        placeholder={
          lang === "AR"
            ? "اكتب محتوى الرسالة هنا..."
            : "Write your email content here..."
        }
       className="
w-full
h-9
px-3
border border-gray-300
rounded-lg
bg-white
text-sm
focus:outline-none focus:ring-2 focus:ring-gray-300
"
      />

     <div className="px-5 py-4 border-t bg-[#f6f6f7] flex justify-end gap-2">
        <button
          onClick={() => setCommunityEmailOpen(false)}
         className="
h-9 px-4
bg-white border border-gray-300
rounded-lg
text-sm
hover:bg-gray-50
"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={sendCommunityEmails}
          className="
h-9 px-4
bg-[#202223]
text-white
rounded-lg
text-sm font-medium
hover:bg-black
"
        >
           {lang === "AR" ? "إرسال" : "Send"}
        </button>
      </div>
    </div>
  </div>
)}


  {whatsappOpen && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">

    <div className="bg-white rounded-lg shadow-xl w-[90%] max-w-4xl max-h-[90vh] overflow-auto p-6">

      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">
         {TEXT.whatsappContacts}
        </h2>

        <div className="flex gap-2 flex-wrap">

          <button onClick={() => handlePrint(phonePrintRef)} className="px-3 py-1 bg-black text-white rounded">
           {TEXT.print}
          </button>

          <button onClick={() => exportCSV(phoneModalData)}className="px-3 py-1 border rounded">
            CSV
          </button>

          <button onClick={() => exportExcel(phoneModalData)}className="px-3 py-1 border rounded">
            Excel
          </button>

          <button onClick={() => exportPDF(phoneModalData)} className="px-3 py-1 border rounded">
            PDF
          </button>

          <button onClick={() => setWhatsappOpen(false)} className="px-3 py-1 border rounded">
            {TEXT.close}
          </button>

        </div>
      </div>

      <div ref={phonePrintRef} id="print-area">
        <table className="w-full text-sm border">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">{TEXT.name}</th>
              <th className="p-2 border">{TEXT.phone}</th>
            </tr>
          </thead>

          <tbody>
            {filtered
              .filter(c => c.phone)
              .map(c => (
                <tr key={c.id}>
                  <td className="p-2 border">{c.name}</td>
                  <td className="p-2 border">{c.phone}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

    </div>
  </div>
)}

</div>

{listOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 print:bg-white print:flex print:items-start">
    <div className="bg-white rounded-2xl shadow-xl w-full max-w-3xl p-6 print:shadow-none print:rounded-none">
      
      {/* HEADER */}
      <div className="flex justify-between items-center mb-4 print:hidden">
        <h3 className="text-lg font-bold text-gray-800">
          {listType === "phone"
            ? lang === "AR" ? "قائمة أرقام الهاتف" : "Phone Numbers List"
            : lang === "AR" ? "قائمة البريد الإلكتروني" : "Emails List"}
        </h3>

        <div className="flex gap-2">
          <button
            onClick={printList}
            className="px-4 py-2 rounded-xl bg-gray-800 text-white text-sm hover:bg-black"
          >
            {lang === "AR" ? "طباعة" : "Print"}
          </button>

          <button
            onClick={() => setListOpen(false)}
            className="px-4 py-2 rounded-xl bg-gray-200 hover:bg-gray-300 text-sm"
          >
            {lang === "AR" ? "إغلاق" : "Close"}
          </button>
        </div>
      </div>

      {/* TABLE SCROLL CONTAINER */}
<div className="max-h-[65vh] overflow-y-auto border border-gray-300 print:max-h-full print:overflow-visible">
  <table className="w-full text-sm">
        <thead className="bg-gray-200">
          <tr>
            <th className="border p-2 text-left">
              {lang === "AR" ? "الاسم الكامل" : "Full Name"}
            </th>
            <th className="border p-2 text-left">
              {listType === "phone"
                ? lang === "AR" ? "رقم الهاتف" : "Phone Number"
                : lang === "AR" ? "البريد الإلكتروني" : "Email"}
            </th>
          </tr>
        </thead>

        <tbody>
          {filtered
            .filter(c => listType === "phone" ? c.phone : c.email)
            .map((c, i) => (
              <tr key={i}>
                <td className="border p-2">{c.name}</td>
                <td className="border p-2">
                  {listType === "phone" ? c.phone : c.email}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
     </div>
    </div>
  </div>
)}
            </>
  )}


                </main>
        
            </div>
{dateOverlayOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="w-[360px] bg-white border border-gray-200 rounded-[18px] shadow-[0_30px_60px_rgba(0,0,0,0.16)] overflow-hidden animate-sortOverlay">

      {/* HEADER */}
      <div className="px-5 py-4 bg-[#f6f6f7] border-b border-gray-200">
        <h3 className="text-[15px] font-semibold text-gray-800">
          {lang === "AR" ? "نطاق تاريخ" : "Date range"}
        </h3>
      </div>

      {/* BODY */}
      <div className="p-4">
        <CalendarRangePicker
          rangeStart={rangeStart}
          rangeEnd={rangeEnd}
          setRangeStart={setRangeStart}
          setRangeEnd={setRangeEnd}
        />
      </div>

      {/* FOOTER */}
      <div className="px-5 py-4 bg-[#f6f6f7] border-t border-gray-200 flex justify-end gap-3">

        <button
          onClick={() => setDateOverlayOpen(false)}
          className="h-[36px] px-4 border rounded-lg bg-white"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={() => {
            if (!rangeStart || !rangeEnd) return;

            const from = formatLocalDate(rangeStart);
            const to = formatLocalDate(rangeEnd);

            setDateFrom(from);
            setDateTo(to);

            setDateOverlayOpen(false);
          }}
          className="h-[36px] px-4 bg-[#202223] text-white rounded-lg"
        >
          {lang === "AR" ? "تطبيق" : "Apply"}
        </button>

      </div>
    </div>
  </div>
)}

{deleteId !== null && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">

    <div className="w-[380px] bg-white rounded-[14px] shadow-xl overflow-hidden">

      {/* HEADER */}
      <div className="px-5 py-4 border-b bg-[#f6f6f7] flex items-center gap-3">
        <div className="w-9 h-9 flex items-center justify-center rounded-full bg-red-50 border">
          <FaUserSlash className="text-red-600 text-sm"/>
        </div>

        <h2 className="text-[15px] font-semibold">
          {lang === "AR" ? "حذف العميل؟" : "Delete customer?"}
        </h2>
      </div>

      {/* BODY */}
      <div className="px-5 py-5 text-sm text-gray-600">
        {deleteId === "bulk"
          ? (lang === "AR"
              ? "سيتم حذف عدة عملاء، لا يمكن التراجع."
              : "You are about to delete multiple customers.")
          : (lang === "AR"
              ? "لا يمكن التراجع عن هذا الإجراء."
              : "This action cannot be undone.")}
      </div>

      {/* FOOTER */}
      <div className="px-5 py-4 border-t flex justify-end gap-3 bg-[#f6f6f7]">

        <button
          onClick={() => setDeleteId(null)}
          className="h-[36px] px-4 border rounded-lg bg-white"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={() => {
            if (deleteId === "bulk") confirmBulkDelete();
            else confirmDelete();
          }}
          className="h-[36px] px-4 bg-red-600 text-white rounded-lg"
        >
          {lang === "AR" ? "حذف" : "Delete"}
        </button>

      </div>
    </div>
  </div>
)}

{toast && (
  <div className="
    fixed bottom-5 right-5 z-[9999]
    animate-fadeSlide
  ">
    <div className="
      flex items-center gap-3
      px-4 py-3
      bg-[#202223]
      text-white
      rounded-lg
      shadow-[0_10px_25px_rgba(0,0,0,0.2)]
      text-sm font-medium
      min-w-[220px]
    ">

      {/* ICON */}
      <div className="
        w-5 h-5 flex items-center justify-center
        rounded-full bg-white/20 text-xs
      ">
        ✓
      </div>

      {/* TEXT */}
      <span>{toast.message}</span>

    </div>
  </div>
)}

        </div>
    );
}

export default AdminCustomers;